/**
 * @generated SignedSource<<38b923f75c07f1c6a64090eea9f56c2a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TermsQuery_Query$variables = Record<PropertyKey, never>;
export type TermsQuery_Query$data = {
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"Terms_viewer">;
  } | null | undefined;
};
export type TermsQuery_Query = {
  response: TermsQuery_Query$data;
  variables: TermsQuery_Query$variables;
};

const node: ConcreteRequest = {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "TermsQuery_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "Terms_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "TermsQuery_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "terms",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c04fca26f670373170eb4b21b4d79b78",
    "id": null,
    "metadata": {},
    "name": "TermsQuery_Query",
    "operationKind": "query",
    "text": "query TermsQuery_Query {\n  viewer {\n    ...Terms_viewer\n    id\n  }\n}\n\nfragment Terms_viewer on Viewer {\n  terms\n}\n"
  }
};

(node as any).hash = "7941258c33c2d7cd4e4883ee2fea9ab8";

export default node;
